import { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          <img src="/logo.png" alt="Logo WSPS - Wourou Sécurité" className="logo-img" />
        </Link>

        {/* Bouton d'appel rapide visible sur tous les écrans */}
        <div className="nav-quick-contact">
          <a href="tel:+33602615612" className="nav-phone-badge" title="Appeler directement WSPS">
            <span className="pulse-dot"></span>
            <span className="phone-icon">📞</span>
            <span className="phone-text">06 02 61 56 12</span>
          </a>
        </div>

        <button
          className={`navbar-toggle ${isOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label="Menu de navigation"
          aria-expanded={isOpen}
        >
          <span className="burger-bar"></span>
          <span className="burger-bar"></span>
          <span className="burger-bar"></span>
        </button>

        <ul className={`navbar-links ${isOpen ? "open" : ""}`}>
          <li><a href="#services" onClick={closeMenu}>Services</a></li>
          <li><a href="#Us" onClick={closeMenu}>Qui sommes-nous ?</a></li>
          <li><a href="#domaines" onClick={closeMenu}>Domaines</a></li>
          <li><a href="#process" onClick={closeMenu}>Notre méthode</a></li>
          <li><a href="#about" onClick={closeMenu}>Coordonnées</a></li>
          <li>
            <a href="#contact" className="nav-cta" onClick={closeMenu}>
              Demander un devis
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}
